module.exports = __webpack_public_path__ + "img/fulfillment.7521cf28.jpg";